import { csx, style } from '@vtex/admin-ui'

export const modalBackdrop = style({
  zIndex: '9998 !important',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-end',
  alignItems: 'center',
  bg: '$overlay',
  div: {
    width: '100%',
  },
  '@tablet': {
    justifyContent: 'flex-end',
  },
  '@desktop': {
    justifyContent: 'center',
  },
})

export const modal = style({
  width: '50%',
  outline: 'none',
  bg: '$primary',
  borderRadius: '$base',
  border: '$neutral',
  position: 'relative',
  overflow: 'hidden',
  maxWidth: '50rem',
  margin: '0.5rem',
  zIndex: 'inherit',
})

const modalHeaderHeight = '90px'

export const modalHeader = style({
  position: 'sticky',
  top: '$space-0',
  left: '$space-0',
  right: '$space-0',
  zIndex: 'inherit',
  width: '100%',
  height: modalHeaderHeight,
})

export const modalTitle = style({
  marginRight: '$space-4',
  whiteSpace: 'nowrap',
})

export const modalContent = style({
  overflowY: 'auto',
  maxHeight: `calc(100% - ${modalHeaderHeight})`,
})

export const dismiss = style({
  margin: 'unset !important',
})

export const modalFooter = csx({
  padding: '16px 28px !important',
})

export const modalMaxHeight = csx({
  maxHeight: '37.5rem',
})

export const modalHeaderBorder = style({
  borderBottom: '1px solid $gray20 !important',
})
